import { format, formatDistance } from 'date-fns';

/**
 * Validates if a timestamp is valid and within reasonable range
 * Handles dates with and without milliseconds
 */
const isValidTimestamp = (timestamp) => {
  if (!timestamp) return false;
  
  // Check if timestamp is too large (beyond year 2100)
  if (typeof timestamp === 'string') {
    // Handle numeric timestamps
    const numericTimestamp = parseInt(timestamp, 10);
    if (!isNaN(numericTimestamp)) {
      // Convert milliseconds to years roughly
      const years = new Date(numericTimestamp).getFullYear();
      if (years > 2100) return false;
    }
    
    // Handle ISO format timestamps with or without milliseconds
    // Examples: "2025-04-21T09:45:21.560513" or "2025-04-21T09:45:21"
    if (timestamp.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/)) {
      // Valid ISO format, continue with date creation
    }
  }
  
  const date = new Date(timestamp);
  return !isNaN(date.getTime()) && date <= new Date('2100-12-31');
};

/**
 * Formats a timestamp as a relative time (e.g., "2 days ago")
 * Handles dates with and without milliseconds
 */
export const formatTimeAgo = (timestamp) => {
  try {
    if (!isValidTimestamp(timestamp)) {
      return 'Invalid date';
    }
    const date = new Date(timestamp);
    return formatDistance(date, new Date(), { addSuffix: true });
  } catch (error) {
    console.error('Error formatting time ago:', error, timestamp);
    return 'Invalid date';
  }
};

/**
 * Formats a timestamp as a readable date and time
 * Handles dates with and without milliseconds
 */
export const formatDateTime = (timestamp) => {
  try {
    if (!isValidTimestamp(timestamp)) {
      return 'Invalid date';
    }
    const date = new Date(timestamp);
    const today = new Date();
    
    if (date.toDateString() === today.toDateString()) {
      return format(date, 'h:mm a');
    }
    return format(date, 'MMM d, yyyy h:mm a');
  } catch (error) {
    console.error('Error formatting date time:', error, timestamp);
    return 'Invalid date';
  }
};

/**
 * Converts a UTC timestamp to local time
 * Handles dates with and without milliseconds
 */
export const formatUTCToLocal = (utcTimestamp) => {
  try {
    if (!isValidTimestamp(utcTimestamp)) {
      return utcTimestamp; // Return original if invalid
    }
    const date = new Date(utcTimestamp);
    return date.toISOString();
  } catch (error) {
    console.error('Error converting UTC to local:', error, utcTimestamp);
    return utcTimestamp; // Return original on error
  }
};
